import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import registerModules from './register-modules'
import registerComponents from './register-components'
import { useAuthStore } from './stores/auth'

// Import global styles
import './assets/main.css'
import './assets/base.css'
import './styles/animations.css'

const app = createApp(App)

// Install plugins
const pinia = createPinia()
app.use(pinia)

// Register modules first (before router installation)
registerModules(app, router)
registerComponents(app)

// Now install the router with all routes registered
app.use(router)

// Initialize auth store and verify token
const authStore = useAuthStore()
if (authStore.isAuthenticated) {
  // Fetch fresh user data on app startup
  authStore.fetchCurrentUser()
}

app.mount('#app')
